// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import customParamSerializer from "@justpark/helpers/src/customParamSerializer/customParamSerializer";
import debug from "../helpers/debug";

type SearchData = {
  lat: string,
  lng: string,
  start_date: string,
  google_place_id: number,
  user_query: string,
  end_date?: string,
  duration?: string,
  filters?: any
};
const getSearchGeoLocation = (
  data: SearchData,
  cancelTokenSource?: any
): ((apiInstance: AxiosInstance) => AxiosPromise) => (apiInstance) => {
  debug("getSearchGeoLocation", data);

  const config = {
    params: {
      ...data,
      cluster: 0,
      driveup: 1,
      show_unavailable: 1
    },
    paramsSerializer: customParamSerializer
  };

  if (cancelTokenSource) {
    config.cancelToken = cancelTokenSource.token;
  }

  return apiInstance.get("/v5/search", config);
};

export default getSearchGeoLocation;
